import React, { PureComponent } from 'react'
import PageHeaderWrapper from '../../../components/PageHeaderWrapper'
import StudentDocUtil from '../../../components/_utils/studentDocUtil'


import { Card, Form } from 'antd'

import Request from '../../../request'
import { connect } from 'react-redux'
import { getUrlPushWrapper } from '../../../routes'
import StudentInfo from '../../../components/StudentInfo'
import StudentHeader from '../../../components/studentHeader'

// const Option = Select.Option

@Form.create()
class StudentDocs extends PureComponent {
    constructor(props) {
        super(props)
        this.state = {
            inquiryId: null,
            info: null
        }
    }

    componentDidMount() {
        let searchParams = new URLSearchParams(this.props.search)
        let inquiryId = searchParams.get('id')
        if (inquiryId) {
            this.setState({ inquiryId: inquiryId })
            this.setFormValues(inquiryId)
        }
    }

    setFormValues = async inquiryId => {
        try {
            let { doc } = await Request.getInquiry(inquiryId + '?page=document')
            console.log(doc);
            if (doc) {
                this.setState({ info: doc })
            }
        } catch (e) {
            console.log(e)
        }
    }

    render() {
        const { dispatch } = this.props
        const { info, inquiryId } = this.state
        return (
            <PageHeaderWrapper title={'Student Documents'}>
                <div>
                    <div style={{ marginBottom: 10 }}>
                        <StudentHeader
                            rollBackLevel={'Registration Desk'}
                            done={() => {
                                dispatch(getUrlPushWrapper('desk.application'))
                            }}
                            info={this.state.inquiryId}
                            data={info}
                            dispatch={this.props.dispatch}
                        />
                    </div>
                </div>

                {
                    info ? <Card bordered={true} style={{ marginBottom: 10 }}>
                        <StudentInfo
                            info={info}
                        />
                    </Card> : null
                }

                {
                    info ? <Card title="Documents" bordered={true}>

                        <StudentDocUtil info={info} />
                    </Card> : null
                }

            </PageHeaderWrapper>
        )
    }
}

const mapStateToProps = ({ global, router }) => ({
    loading: global.buttonLoading,
    categories: global.categories,
    search: router.location.search
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(StudentDocs)
